import React from "react";

const Icon = props => (
  <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" focusable="false" {...props}>
    <path fill="currentColor" d="M25.4,4.53,3.49,13.06s-1,.38-1,1,1,1,1,1L9.06,16.9,22.3,8.49s.74-.5.74,0c0,0,.13.12-.24.49s-10.4,9.41-10.4,9.41l-.74,6.18c.25.13.62-.12.62-.12l3.59-3.22,5.57,4.33a1.56,1.56,0,0,0,2.1-.74l4-19.68C27.25,3.66,25.4,4.53,25.4,4.53Z" />
  </svg>
);

export default Icon;
